// frontend/admin-portal/src/services/paymentService.js
import api from './axiosConfig';

export const paymentService = {
    list: async (params = {}) => {
        const { data } = await api.get('/payments', { params });
        return data.data;
    },
    create: async (payload) => {
        const { data } = await api.post('/payments', payload);
        return data.data.payment;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/payments/${id}`);
        return data.data;
    },
};